import { ApiCallsFactory, LocalPersistence } from '../../../../factories/index';
import { detailDataType, optionsDataTypePost } from './types';

// setting the dinamyc data
const setData = (
  type: string,
  index: number,
  value: string,
  data: string[],
  detailData: {
    [key: string]: number | string;
  }[],
  actionType: (a: string[]) => void
) => {
  const notEmpty = /^(?!\s*$).+/;
  let tempArray: string[] = [];
  if (notEmpty.test(value)) {
    tempArray = data;
    tempArray[index] = value;
    detailData[index][type] = value;
    actionType(tempArray);
    return true;
  }
  return false;
};

// getting the session data
const getSession = async () => {
  const get_session = new LocalPersistence('session');
  const session = await get_session.getSessionPersistence();
  return session;
};

// getCall
const getHelper = async (url: string) => {
  const currentSession = await getSession();
  const getService = new ApiCallsFactory(
    `${url}?supplier=${currentSession?.supplier}&propertyid=${currentSession?.propertyId}`,
    currentSession.token
  );
  const response = await getService.getData();
  return response;
};

// post call helper
const postHelper = async (url: string, body: object) => {
  try {
    const currentSession = await getSession();
    const postBody = {
      ...body,
      supplier: currentSession.supplier,
      propertyId: currentSession.propertyId,
    };
    const postService = new ApiCallsFactory(
      url,
      currentSession.token,
      postBody
    );
    const response = await postService.postData();
    return response;
  } catch (error: any) {
    return error;
  }
};

// post call
const post = async (
  detaildata: optionsDataTypePost,
  id: string | undefined | null,
  langid: string | undefined | null
) => {
  /* istanbul ignore next */
  try {
    const body = {
      supplier: '',
      propertyId: '',
      property: {
        environmentalimpact: {
          id,
          langid,
          recyclingprogram: detaildata,
        },
      },
    };
    const response = await postHelper('/property/env/recyclingprogram', body);
    return response;
    // persisting the post data
  } catch (error: any) {
    throw new Error('Error posting the data');
  }
};

export { setData, post, getHelper };
